<template>
    <div>
        <calendar-mobile v-if="isMobile" />
        <calendar-desktop v-else />

        <ai-chat-drawer />
    </div>
</template>

<script>

import CalendarMobile from "@/components/coach/routines/CalendarMobile";
import CalendarDesktop from "@/components/coach/routines/CalendarDesktop";
import { Screen } from "@/utils/Capacitor";
import AiChatDrawer from '@/components/coach/ai/AiChatDrawer';

export default {
    components: {
        CalendarDesktop,
        CalendarMobile,
        AiChatDrawer,
    },
    data() {
        return {
            //
        }
    },
    mounted() {
        Screen.unlock()
    },
    beforeDestroy() {
        Screen.lockPortrait()
    },
}
</script>

<style scoped>

</style>
